<template>
  <v-card dark class="device-legend pa-2" outlined>
    <div class="d-flex align-center mb-1">
      <v-icon small color="white" class="mr-1">mdi-access-point</v-icon>
      <span class="text-caption font-weight-bold white--text">DEVICES</span>
    </div>
    <div
        v-for="device in devices"
        :key="device.slug"
        class="device-legend-item d-flex align-center py-1 px-1"
        :class="{ 'device-legend-item--hidden': !device_visibility[device.slug] }"
        @click="toggle(device.slug)"
    >
      <div
          class="device-color-dot mr-2"
          :style="{ background: get_device_color(device.slug), opacity: device_visibility[device.slug] ? 1 : 0.3 }"
      ></div>
      <span
          class="text-caption"
          :style="{ opacity: device_visibility[device.slug] ? 1 : 0.4 }"
      >
        {{ device.name }}
      </span>
      <v-chip
          v-if="device.released_after_id === null"
          x-small
          color="orange darken-1"
          class="ml-1 debug-chip"
          label
      >DBG</v-chip>
    </div>
  </v-card>
</template>

<script>
import {PointsStore} from "@/store";
import {storeToRefs} from 'pinia';

export default {
  name: "DeviceLegend",
  setup() {
    const points_store = PointsStore();
    const {devices, device_visibility} = storeToRefs(points_store);
    return {points_store, devices, device_visibility};
  },
  methods: {
    toggle(slug) {
      this.points_store.toggle_device_visibility(slug);
    },
    get_device_color(slug) {
      return this.points_store.get_device_color(slug);
    }
  }
}
</script>

<style scoped>
.device-legend {
  background: rgba(30, 30, 30, 0.85) !important;
  backdrop-filter: blur(4px);
  border-radius: 8px !important;
  min-width: 160px;
}
.device-legend-item {
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.15s;
}
.device-legend-item:hover {
  background: rgba(255, 255, 255, 0.08);
}
.debug-chip {
  height: 14px !important;
  font-size: 9px !important;
  padding: 0 4px !important;
}
.device-color-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.6);
  flex-shrink: 0;
  transition: opacity 0.15s;
}
</style>
